'use client';

import type { LucideIcon } from 'lucide-react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { AdminButton } from './AdminButton';

type Props = {
  title?: string;
  message?: string;
  description?: string;
  icon?: LucideIcon;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
};

export function AdminErrorState({
  title = 'Failed to load data',
  message,
  description,
  icon: Icon = AlertCircle,
  onRetry,
  retryLabel = 'Retry',
  className = '',
}: Props) {
  const detail =
    message ||
    description ||
    'An unexpected server error occurred while retrieving this data. Please try again.';

  return (
    <div
      className={`rounded-2xl border border-dashed border-red-300/80 bg-red-50/50 p-10 text-center shadow-xs ${className}`}
      role="alert"
    >
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-red-100 text-red-600">
        <Icon className="h-6 w-6" aria-hidden />
      </div>
      <p className="text-base font-semibold text-soot">{title}</p>
      <p className="mx-auto mt-2 max-w-md text-sm text-moss">{detail}</p>
      {onRetry && (
        <div className="mt-5 flex justify-center">
          <AdminButton
            type="button"
            variant="secondary"
            size="sm"
            icon={RefreshCw}
            onClick={onRetry}
          >
            {retryLabel}
          </AdminButton>
        </div>
      )}
    </div>
  );
}
